// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BoundedAxis
 */
export interface BoundedAxis {
  /**
   *
   */
  origin: number;
  /**
   *
   */
  cellSize: number;
  /**
   *
   */
  size: number;
}

/**
 * Check if a given object implements the BoundedAxis interface.
 */
export function instanceOfBoundedAxis(value: object): value is BoundedAxis {
  if (!("origin" in value) || value["origin"] === undefined) return false;
  if (
    (!("cellSize" in (value as Record<string, any>)) &&
      !("cell_size" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["cellSize"] === undefined &&
      (value as Record<string, any>)["cell_size"] === undefined)
  )
    return false;
  if (!("size" in value) || value["size"] === undefined) return false;
  return true;
}

export function BoundedAxisFromJSON(json: any): BoundedAxis {
  return BoundedAxisFromJSONTyped(json, false);
}

export function BoundedAxisFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoundedAxis {
  if (json == null) {
    return json;
  }
  return {
    origin: json["origin"],
    cellSize: json["cell_size"],
    size: json["size"],
  };
}

export function BoundedAxisToJSON(json: any): BoundedAxis {
  return BoundedAxisToJSONTyped(json, false);
}

export function BoundedAxisToJSONTyped(
  value?: BoundedAxis | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    origin: value["origin"],
    cell_size: value["cellSize"],
    size: value["size"],
  };
}
